import React from 'react';
import { ActivityTimeline } from '../ActivityTimeline';

interface TimelinePanelProps {
  riskId?: string;
  borrowerProjectId?: string;
}

/**
 * Panel content component for displaying the activity timeline.
 * This component is rendered inside a GenericPanel.
 * It's read-only (no submit/delete actions).
 */
export const TimelinePanel: React.FC<TimelinePanelProps> = ({
  riskId,
  borrowerProjectId
}) => {
  return (
    <div className="h-full p-4">
      <ActivityTimeline riskId={riskId} borrowerProjectId={borrowerProjectId} />
    </div>
  );
};

export default TimelinePanel;
